import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter(); // should be inside IvrBuilder?

export default eventEmitter;
